<template>
  <div class="col col-xs-12 col-md-6 col-lg-4">
    <div class="card m-1">
      <div class="card-body">
        <div class="dropdown">
          <h3 class="dropdown-toggle btn btn-block btn-secondary" type="button" :id="bot.token" data-toggle="dropdown" aria-expanded="false">
            {{ bot.first_name }}<i class="bi bi-three-dots-vertical"></i>
          </h3>
          <div class="dropdown-menu" :aria-labelledby="bot.token">
            <button class="dropdown-item" type="button" @click="$router.push({ name: 'editor', params: { token: bot.token }})">Edit</button>
            <button class="dropdown-item" type="button" @click="$router.push({ name: 'dashboard', params: { propToken: bot.token }})">Dashboard</button>
            <button class="dropdown-item" type="button" @click="toChat(bot.username)">Chat</button>
            <button class="dropdown-item" type="button" @click="$emit('deleteBot',bot.token)">Delete</button>
          </div>
        </div>
        <div>
          <p class="card-subtitle text-muted">{{ bot.token }}</p>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  name: 'BotCard',
  props:{
    bot: Object
  },
  methods: {
    toChat: function(username) {
      const link = "https://t.me/"+username
      window.open(link, "_blank");
    },
  }
}

</script>
